import {useContext, useState} from 'react';
import AuthContext from '../../context/AuthContext';
import AutocOneTrgFeat from '../_subcomponents/AutocOneTrgFeat';
import AutocOneTrgVal from '../_subcomponents/AutocOneTrgVal';
import AutocOneTrgCat from '../_subcomponents/AutocOneTrgCat';


export default function FeatUsemapTrgBlock(props: any) {
    let {user, logoutUser, authTokens} = useContext(AuthContext)

    const {trgCatsOptions, trgObj, setTrgObj, setUsemapExists, projUID, setUsemapRedirectURL} = props

    const [trgCatFeats, setTrgCatFeats] = useState<any[]>([])

    return (
        <div className="featmap-trg-container">
            {/*{trgCats.toString()}*/}

            <div className="featmap-trg-subcont">
                <div className='field-label'>Category ID</div>
                <input
                    name='catID'
                    type="text"
                    className='readonly-input'
                    value={trgObj.catID || ''}
                    readOnly
                />
            </div>

            <div className="featmap-trg-subcont">
                <div className='field-label'>Category Name</div>
                <AutocOneTrgCat
                    name='trgCatName'
                    trgObj={trgObj}
                    setTrgObj={setTrgObj}
                    valsArr={trgCatsOptions}
                    setTrgCatFeats={setTrgCatFeats}
                    setUsemapExists={setUsemapExists}
                />
            </div>

            <div className="featmap-trg-subcont">
                <div className='field-label'>Feature ID</div>
                <input
                    name='featID'
                    type="text"
                    className='readonly-input'
                    value={trgObj.featID || ''}
                    readOnly
                />
            </div>

            <div className="featmap-trg-subcont">
                <div className='field-label'>Feature Name</div>
                <AutocOneTrgFeat
                    name="featName"
                    trgObj={trgObj}
                    setTrgObj={setTrgObj}
                    valsArr={trgCatFeats}
                    setUsemapExists={setUsemapExists}
                    projUID={projUID}
                    setUsemapRedirectURL={setUsemapRedirectURL}
                />
            </div>

            <div className="featmap-trg-subcont">
                <div className='field-label'>Feature Type</div>
                <input
                    name='featType'
                    type="text"
                    className='readonly-input'
                    value={trgObj.featType || ''}
                    readOnly
                />
            </div>

            <div className="featmap-trg-subcont">
                <div className='field-label'>Class</div>
                <input
                    name='featStatus'
                    type="text"
                    className='readonly-input'
                    value={trgObj.featStatus || ''}
                    readOnly
                />
            </div>

            <div className="featmap-trg-subcont">
                <div className='field-label'>Unit(s)</div>
                <input
                    name='featUnit'
                    type="text"
                    className='readonly-input'
                    value={trgObj.featUnit || ''}
                    readOnly
                />
            </div>

            <div className="featmap-trg-subcont">
                <div className='field-label'>Target Value</div>
                <AutocOneTrgVal
                    name='trgValName'
                    trgObj={trgObj}
                    setTrgObj={setTrgObj}
                    setUsemapExists={setUsemapExists}
                    projUID={projUID}
                    setUsemapRedirectURL={setUsemapRedirectURL}
                />
            </div>

        </div>
    )
}
